import {fork, put, select, take} from 'redux-saga/effects';
import modalIds from '../../modalIds';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as feesAndEstimationActionTypes from '../feesAndEstimationActionTypes';

const loadAssistanceFees = function* loadAssistanceFees({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const pricingManagementService = serviceManager.loadService('pricingManagementService');
    const {location} = payload;

    if (location && location.state?.isModalOpen
        && location.state?.modalId === modalIds.ASSISTANCE_FEES_AND_ESTIMATION_EDIT_MODAL
    ) return;

    yield fork(
        fetchRequest,
        feesAndEstimationActionTypes.FETCH_ASSISTANCE_FEES_REQUEST,
        pricingManagementService.getFees,
    );

    const responseAction = yield take([
        feesAndEstimationActionTypes.FETCH_ASSISTANCE_FEES_REQUEST_SUCCEEDED,
        feesAndEstimationActionTypes.FETCH_ASSISTANCE_FEES_REQUEST_FAILED,
    ]);

    if (responseAction.error) return;

    const {response} = responseAction.payload;
    const {fees} = response;
    yield put({
        type: feesAndEstimationActionTypes.STORE_ASSISTANCE_FEES,
        payload: {fees},
    });
};

export default loadAssistanceFees;
